/**
 * Redux-enabled view for the New User page (first page of the New User app)
 */

import { connect } from 'react-redux';

import PureNewUser from './new-user-view.jsx';
import { requestPopView } from 'phoenix2/state/views/actions';
import { submitPasswordRequest, resetPasswordHandoutError } from 'phoenix2/state/new-user/actions';
import { getNewUserState } from 'phoenix2/state/new-user/selectors';
import { getConfigParameter } from 'phoenix2/state/config-params/selectors';
import { analyticsHit } from 'phoenix2/state/analytics/actions';

export const mapStateToProps = state => ({
    // Whether there has been an error when submitting the form
    error: getNewUserState(state).get('error'),

    throttled: getNewUserState(state).get('errorThrottled'),

    // Whether to disable animations (on validation message):
    disableAnimations: getConfigParameter(state, 'disableAnimations'),

    // Whether we are in password reset mode, alters messaging on page
    passwordResetMode: window.settings.nuForgotDetailsMode,
});

export const mapDispatchToProps = dispatch => ({
    // Called when the user submits the form
    onSubmit: (firstName, lastName, dateOfBirth) =>
        dispatch(submitPasswordRequest(firstName, lastName, dateOfBirth)),

    // Called when the user updates a form field after being shown a validation
    // error, which removes the error message
    onResetError: () => dispatch(resetPasswordHandoutError()),

    onBack: () => dispatch(requestPopView()),

    onSelectItem: (type, item, withKeyboard = false) => {
        // In Parent Portal one menu item contains the user name, which we
        // do not wish to pass through to analytics
        let i = item;
        if (item.toLowerCase().indexOf('log in as') !== -1) {
            i = 'Log in as student';
        }

        dispatch(
            analyticsHit('event', {
                eventCategory: type,
                eventAction: i,
                eventLabel: {
                    method: withKeyboard ? 'keyboard' : 'tap',
                },
            }),
        );
    },
});

export const connectNewUserView = connect(mapStateToProps, mapDispatchToProps);

export const NewUserView = connectNewUserView(PureNewUser);

NewUserView.displayName = 'NewUserViewContainer';
